import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Configs from '../configs/Configs'
import Login from '../login/Login'
import WelcomeSignUp from '../welcome/WelcomeSignUp'
import RequireAuth from './RequireAuth'
import Project from '../todos/Project'
import InviteUser from '../team/InviteUser'
import MyOrganProfile from '../user/MyOrganProfile'
import TestoRama from '../testorama/TestoRama'
import Logout from '../login/Logout'
import AboutKiponos from '../welcome/AboutKiponos'
import DoIt from '../doit/DoIt'
import MultiPageDocs from '../docs/MultiPageDocs'
import './Routing.css';
import Avoda from '../avoda/Avoda'

export default function Routing() {
  return (
    <div className='routingWrap'>
      <Routes>
        <Route exact path='/signup'           element={<WelcomeSignUp />}                                   key='/signup'/>
        <Route exact path='/about'            element={<AboutKiponos />}                                    key='/about'/>
        <Route exact path='/invite-user'      element={<RequireAuth> <InviteUser />       </RequireAuth>}   key='/invite-user'/>
        <Route exact path='/login'            element={<Login />}                                           key='/login'/>
        <Route exact path='/logout'           element={<Logout />}                                          key='/logout'/>
        <Route exact path='/configs/:showSdk' element={<RequireAuth> <Configs/>           </RequireAuth> }  key='/configs'/>
        <Route exact path='/my-profile'       element={<RequireAuth> <MyOrganProfile />   </RequireAuth>}   key='/my-profile'/>
        <Route exact path='/todo'             element={<RequireAuth> <Project />          </RequireAuth>}   key='/todo'/>
        <Route exact path='/testorama'        element={<TestoRama />         }                              key='/testorama'/>
        <Route exact path='/doit'             element={<RequireAuth> <DoIt />             </RequireAuth>}   key='/doit'/>         
        <Route exact path='/avoda'            element={<RequireAuth> <Avoda />            </RequireAuth>}   key='/avoda'/>
        <Route exact path='/docs'             element={<MultiPageDocs />}                                   key='/docs' />
      </Routes>
    </div>
  )
}

// <Route exact path='/teamfun'    element={<RequireAuth> <TeamSnooker />  </RequireAuth>}      key='/teamfun'/>
// <Route exact path='/monster'    element={<Monster />}                                        key='/monster'/> 
// <Route exact path='/simple'     element={<Simple />}                                         key='/simple'/> */}
// <Route exact path='/events/*'   element={<Events/> }                                         key='/events'/>*/}